"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newTimecode = void 0;
function newTimecode(hours, minutes, seconds, frames, framerate) {
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        frames: frames,
        framerate: framerate,
    };
}
exports.newTimecode = newTimecode;
